module.exports = __webpack_public_path__ + "static/media/L5-Node_js.69a09ead.svg";